import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import DataGrid, {
  Column,
  Selection,
  Sorting,
  Scrolling
} from 'devextreme-react/data-grid';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Constants } from 'utilities/constants';

const styles = theme => ({
  root: {
    // marginTop: 16,
    // margin: '0px 8px 8px'
    minHeight: 152
  },
  title: {
    marginBottom: 8,
    // marginLeft: 8
  },
  grid: {
    maxHeight: 400
  }
});

const TransactionEventHistoryGrid = ({ classes, location, gudTransactionEvents }) => {
    return (
    <div className={classes.root}>
      {
        gudTransactionEvents && gudTransactionEvents?.length > 0 ?
          <>
            <DataGrid
              dataSource={gudTransactionEvents}
              showBorders={true}
              showRowLines={true}
              showColumnLines={true}
              className={classes.grid}
              hoverStateEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              width='100%'
              height={location.pathname === Constants.Routes.EXPLORE 
                ? undefined 
                : location.pathname.startsWith(Constants.Routes.POSTACQ_TASK)
                  ? 198
                  : 152
              }
            >
              <Scrolling mode='virtual' />
              <Sorting mode={'multiple'} />
              <Selection mode='single' />
              <Column dataField='dateFormat' caption='Date' dataType='date' width={100} sortOrder={'desc'} sortIndex={0} />
              <Column dataField='event' caption='Event' dataType='string' width={120} />
              <Column dataField='eventSubtype' caption='Event Sub-Type' dataType='string' width={150} />
              <Column dataField='price' caption='Price' dataType='number' format={{ type: 'currency', precision: 0 }} width={100} />
              <Column dataField='pricePerSqFt' caption='$/SqFt' dataType='number' format={{ type: 'currency', precision: 2 }} width={100} />
              <Column dataField='dom' caption='DOM' dataType='number' width={80} />
              <Column dataField='source' caption='Source' dataType='string' width={200} />
            </DataGrid>
          </>
          :
          <Typography className={classes.title} variant="subtitle2">
            No transaction events
          </Typography>
      }
    </div>
  );
};

export default compose(withRouter, withStyles(styles))(TransactionEventHistoryGrid);
